import React, { useEffect } from 'react'
import Loading from 'core/subapps/Loading'
import storage from 'util/storage'
import ClassicView from './ClassicView'
import ModernView from './ModernView'

const storageSearchKeysForMailboxAndTicket = [
  'lastSearchQueryId',
  'ticketListForLastViewedTicket',
  'latestMailboxContext',
  'ticketListFromFirstPinnedSearch',
]

export default function LayoutSwitcher(props) {
  const {
    isBootstrapped,
    prefersClassicView,
    realMailboxes,
    redirectToSearchPageWithMailboxAndFolder,
  } = props

  useEffect(
    () => {
      const hasMailboxOrTicketSearch = storageSearchKeysForMailboxAndTicket.find(
        key => !!storage.get(key)
      )
      if (
        !isBootstrapped ||
        hasMailboxOrTicketSearch ||
        realMailboxes.length === 0
      ) {
        return
      }
      const firstMailbox = realMailboxes[0]
      const firstMailboxId = firstMailbox?.id
      const firstFolderId = firstMailbox?.folders?.[0]
      redirectToSearchPageWithMailboxAndFolder(firstMailboxId, firstFolderId)
    },
    [realMailboxes, isBootstrapped, redirectToSearchPageWithMailboxAndFolder]
  )

  useEffect(
    () => {
      if (prefersClassicView) {
        document.body.classList.toggle('classic-inbox-view', true)
        document.body.classList.toggle('modern-inbox-view', false)
      } else {
        document.body.classList.toggle('classic-inbox-view', false)
        document.body.classList.toggle('modern-inbox-view', true)
      }
    },
    [prefersClassicView]
  )

  if (!isBootstrapped) return <Loading />

  if (prefersClassicView) {
    return <ClassicView {...props} />
  }

  return <ModernView {...props} />
}
